import React from 'react';
import { Button, Typography } from '@material-ui/core';

const toButtonLabel = role =>
	String(role ?? '')
		.trim()
		.replace(/[_-]+/g, ' ')
		.replace(/\b\w/g, char => char.toUpperCase());

export default function ChooseRolePanel({ roles = [], onSelect, disabled }) {
	return (
		<div className="w-full mt-12">
			<Typography variant="subtitle1" className="w-full text-center mb-8 opacity-80 text-xs">
				Choose a role to continue
			</Typography>

			{Array.isArray(roles) && roles.length > 0 ? (
				<div className="flex flex-wrap gap-8">
					{roles.map(role => (
						<Button
							className="flex-1"
							key={String(role)}
							variant="contained"
							disabled={!!disabled}
							onClick={() => onSelect?.(role)}
						>
							{toButtonLabel(role)}
						</Button>
					))}
				</div>
			) : (
				<Typography variant="body2" className="opacity-60 text-xs text-center">
					No roles available yet.
				</Typography>
			)}
		</div>
	);
}
